<template>
  <div>
    <section class="main-content">
        <div class="inner-banner">
            <div class="container">
                <div class="articles-box">
                    <figure class="pic articles-pic fitimg mb-0">
                        <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/song/'+ this.getCategory.image_origin" />
                    </figure>
                    <div class="text">
                        <h3 class="title text-primary">{{this.getCategory.title}}</h3>
                        <article class="article-editor" v-html="this.getCategory.longcontext"></article>
                    </div>
                </div>
            </div>
        </div>
        <!--Songs latest-->
        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title title-bg-music"><span>最新上刊</span></h3>
                            <div class="articles-items">

                                <div class="song-list">
                                    <div class="song-item song-mainitem row">
                                        <div class="col-md-4">歌曲</div>
                                        <div class="col-md-4">歌者</div>
                                        <div class="col-xl-3 col-md-2">刊登時間</div>
                                        <div class="col-xl-1 col-md-2"></div>
                                    </div>

                                    <div class="song-item row" v-for="song in songLatest">
                                        <div class="col-md-4 song-item-name">{{song.title}}</div>
                                        <div class="col-md-4 song-item-author">{{song.author}}</div>
                                        <div class="col-xl-3 col-md-2 col-8 song-item-date">{{song.updated_at.substr(0,10)}}</div>
                                        <div class="col-xl-1 col-md-2 col-4 text-center song-item-btn">
                                          <a class="btn-song-detail" :href="'/songs/'+song.id">聆聽去</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--HOT-->
        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title title-bg-music"><span>{{this.songQty}}首{{this.getCategory.title}}歌曲</span></h3>
                            <div class="articles-items">

                                <form class="form-inline">
                                    <label class="mr-sm-2" for="inlineFormCustomSelect">挑選歌曲</label>

                                    <label class="mr-sm-2" for="inlineFormCustomSelect">語文</label>
                                    <select class="custom-select mb-2 mr-sm-2 mb-sm-0" v-model="chooseLang">
                                        <option value="" selected>請選擇</option>
                                        <option v-for="option in lang" v-bind:value="option.id">
                                            {{option.title}}
                                        </option>
                                    </select>

                                    <label class="mr-sm-2" for="inlineFormCustomSelect">節奏</label>
                                    <select class="custom-select mb-2 mr-sm-2 mb-sm-0" v-model="chooseTempo">
                                        <option value="" selected>請選擇</option>
                                        <option v-for="option in tempo" v-bind:value="option.id">
                                            {{option.title}}
                                        </option>
                                    </select>
                                    <input type="text" class="form-control" v-model="keyword" placeholder="歌曲名稱 / 作者" aria-describedby="basic-addon1">
                                    <!-- <button type="submit" class="btn btn-primary">Submit</button> -->
                                </form>
                                <div class="song-list">
                                    <div class="song-item song-mainitem row">
                                        <div class="col-md-3">歌曲</div>
                                        <div class="col-md-3">歌者</div>
                                        <div class="col-xl-2 col-md-2">収藏數</div>
                                        <div class="col-xl-3 col-md-2">刊登時間</div>
                                        <div class="col-xl-1 col-md-2"></div>
                                    </div>
<paginate
  name="languages"
  :list="songdata"
  :per="10"
  tag="div"
  class="paginate-langs"
>
  <div class="song-item row" v-for="songdata in paginated('languages')">
      <div class="col-md-3 song-item-name">{{songdata.title}}</div>
      <div class="col-md-3 song-item-author">{{songdata.author}}</div>
      <div class="col-xl-2 col-md-2">{{songdata.favorite}}</div>
      <div class="col-xl-3 col-md-2 col-8 song-item-date">{{songdata.created_at.substr(0,10)}}</div>
      <div class="col-xl-1 col-md-2 col-4 text-center song-item-btn">
        <a class="btn-song-detail" :href="'/songs/'+songdata.id">聆聽去</a>
      </div>
  </div>
</paginate>

<nav aria-label="Page navigation example" class="song-pagination">
<paginate-links
  for="languages"
  :simple="{
    prev: '上一頁',
    next: '下一頁'
  }"
  :classes="{
    'ul': ['pagination','pagination-sm'],
    'li': 'page-item',
    '.next > a': ['page-link','next-link'],
    '.prev > a': ['page-link','prev-link', 'another-class'] // multiple classes
  }"
></paginate-links>
</nav>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Qs from 'qs'
export default {
  name: 'songs',
  data () {
    return {
      uri: this.$store.getters.getUri,
      categoryId: 0,
      category: {},
      songdata: Object,
      saveSongData: Object,
      songLatest: Object,
      chooseLang: '',
      chooseTempo: '',
      songQty: 0,
      keyword: '',
      paginate: ['languages']
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getSongTagLang',
      tempo: 'getSongTagTempo'
    }),
    getCategory () {
      return this.$store.getters.getSongCategory[this.$route.params.id - 1]
    }
  },
  mounted: function () {
    this.categoryId = this.$route.params.id
    this.searching()
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ]),
    searching () {
      let self = this
      // 取得分類中的歌曲
      if (this.categoryId !== '') {
        let uploadData = Qs.stringify({
          categoryId: this.categoryId
        })
        this.$http.post(this.uri + 'Song/get_songs_by_category', uploadData).then(function (res) {
          let data = res.data
          if (data.status === 200) {
            // self.songdata = data.songs
            self.saveSongData = data.songs
            self.songLatest = data.songsLatest
            self.songQty = data.songs.length
          } else {
            console.log('下載歌曲失敗')
          }
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        return false
      }
    },
    filterSong () {
      let lang = this.chooseLang
      let tempo = this.chooseTempo
      this.songdata = this.saveSongData
      if (lang !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_1.indexOf(lang) >= 0
        })
      }
      if (tempo !== '') {
        this.songdata = this.songdata.filter(value => value.tag_3 === tempo)
        console.log(this.songdata.length + '總筆')
      }
      if (this.songdata.length < 1) {
        window.alert('尚無歌曲')
      }
    },
    filterKeyword () {
      let keyword = this.keyword
      if (keyword !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.author.indexOf(keyword) >= 0 || value.title.indexOf(keyword) >= 0
        })
      } else {
        this.songdata = this.saveSongData
      }
    }
    // this.$store.dispatch('b')
  },
  watch: {
    chooseLang: {
      handler: function (val, oldVal) {
        this.filterSong()
      }
    },
    chooseTempo: {
      handler: function (val, oldVal) {
        this.filterSong()
      }
    },
    keyword: {
      handler: function (val, oldVal) {
        this.filterKeyword()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Songs.vue?0bb71100